import { render, staticRenderFns } from "./XDown.vue?vue&type=template&id=85dd6f46&"
import script from "./XDown.vue?vue&type=script&lang=js&"
export * from "./XDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports